namespace GeniuzPOS.Common.Helpers {

    export interface ExcelExportOptions {
        grid: Serenity.DataGrid<any, any>;
        service: string;
        onViewSubmit: () => boolean;
        // editRequest?: (request: Serenity.ListRequest) => Serenity.ListRequest;
        editRequest?: (request: GeniuzPOS.Common.Helpers.ExportExcelListRequest) => GeniuzPOS.Common.Helpers.ExportExcelListRequest;
        title?: string;
        hint?: string;
        separator?: boolean;

        // Add
        reportTitle?: string;
        columnStyles?: { [dataKey: string]: AutoTableStyles };
        withExportedDate?: boolean;
        withUsername?: boolean;
        createFilterDescriptions?: (options: ExcelExportOptions) => string[];
    }

    export namespace ExcelExportHelper {

        export function createToolButton(options: ExcelExportOptions): Serenity.ToolButton {

            return {
                hint: Q.coalesce(options.hint, 'Excel'),
                title: Q.coalesce(options.title, ''),
                cssClass: 'export-xlsx-button',
                onClick: function () {
                    if (!options.onViewSubmit()) {
                        return;
                    }

                    let grid = options.grid;

                    // var request = Q.deepClone(grid.getView().params) as Serenity.ListRequest;
                    var request = Q.deepClone(grid.getView().params) as GeniuzPOS.Common.Helpers.ExportExcelListRequest;
                    request.Take = 0;
                    request.Skip = 0;
                    var sortBy = grid.getView().sortBy;
                    if (sortBy) {
                        request.Sort = sortBy;
                    }

                    request.ExportColumns = [];
                    let columns = grid.getGrid().getColumns();
                    for (let column of columns) {
                        request.ExportColumns.push(column.id || column.field);
                    }

                    let filterDescriptions: string[] = [];
                    if (!!options.createFilterDescriptions) {
                        filterDescriptions = options.createFilterDescriptions(options);
                    }

                    if (options.editRequest)
                        request = options.editRequest(request);

                    Q.postToService({ service: options.service, request: request, target: '_blank' });
                },
                separator: options.separator
            };
        }
    }
}
